// extracted by mini-css-extract-plugin
export default {"editButton":"payRollUpload_editButton__gR39h","TableBody":"payRollUpload_TableBody__50Cy3","deleteButton":"payRollUpload_deleteButton__LazmX"};